/**
 * Widget Wizard Icons
 * SVG icons extracted from Figma for visualization types
 */

import React from 'react';
import PropTypes from 'prop-types';

const iconProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
};

export function KPIIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M2 12H6L9 3L15 21L18 12H22" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function PieChartIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M21 12C21.552 12 22.005 11.551 21.95 11.002C21.7195 8.70617 20.7021 6.5607 19.0703 4.92932C17.4386 3.29794 15.2929 2.28104 12.997 2.051C12.447 1.996 11.999 2.449 11.999 3.001V11.001C11.999 11.2662 12.1044 11.5206 12.2919 11.7081C12.4794 11.8956 12.7338 12.001 12.999 12.001L21 12Z" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M21.21 15.89C20.5738 17.3945 19.5788 18.7202 18.3119 19.7513C17.045 20.7824 15.5448 21.4874 13.9424 21.8048C12.3401 22.1221 10.6844 22.0421 9.12015 21.5718C7.55587 21.1014 6.13062 20.2551 4.96902 19.1067C3.80741 17.9582 2.94481 16.5428 2.45663 14.9839C1.96846 13.4251 1.86956 11.7705 2.1686 10.1646C2.46763 8.55878 3.1555 7.05063 4.17205 5.77203C5.1886 4.49343 6.50288 3.48332 8 2.83" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DonutChartIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <circle 
        cx="12" 
        cy="12" 
        r="9" 
        stroke="currentColor" 
        strokeWidth="2" 
        fill="none"
      />
      <circle 
        cx="12" 
        cy="12" 
        r="4" 
        stroke="currentColor" 
        strokeWidth="2" 
        fill="none"
      />
    </svg>
  );
}

export function BarChartIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path d="M18 17V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13 17V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 17V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function GroupedBarChartIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path d="M4 21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 21V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 21V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 21V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function StackedBarChartIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M3 12H7M3 8H7M3 16H7M3 20H7" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M10 10H14M10 6H14M10 14H14M10 18H14" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M17 12H21M17 8H21M17 16H21M17 20H21" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LineChartIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M16 7H22V13" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M22 7L13.5 15.5L8.5 10.5L2 17" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TableIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M9 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V9M9 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V9M9 3V21M3 9V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H9M3 9H21M21 9V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H9" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TextIcon({ className }) {
  return (
    <svg {...iconProps} className={className}>
      <path 
        d="M4 7V4H20V7" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M9 20H15" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12 4V20" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowUpIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path 
        d="M12 10L8 6L4 10" 
        stroke="currentColor" 
        strokeWidth="1.33333" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Map of icon components by widget type
export const ICON_MAP = {
  metric: KPIIcon,
  pie: PieChartIcon,
  donut: DonutChartIcon,
  bar: BarChartIcon,
  'grouped-bar': GroupedBarChartIcon,
  'stacked-bar': StackedBarChartIcon,
  line: LineChartIcon,
  table: TableIcon,
  text: TextIcon,
};

// PropTypes for all icon components
const iconPropTypes = {
  className: PropTypes.string,
};

const iconDefaultProps = {
  className: '',
};

KPIIcon.propTypes = iconPropTypes;
KPIIcon.defaultProps = iconDefaultProps;

PieChartIcon.propTypes = iconPropTypes;
PieChartIcon.defaultProps = iconDefaultProps;

DonutChartIcon.propTypes = iconPropTypes;
DonutChartIcon.defaultProps = iconDefaultProps;

BarChartIcon.propTypes = iconPropTypes;
BarChartIcon.defaultProps = iconDefaultProps;

GroupedBarChartIcon.propTypes = iconPropTypes;
GroupedBarChartIcon.defaultProps = iconDefaultProps;

StackedBarChartIcon.propTypes = iconPropTypes;
StackedBarChartIcon.defaultProps = iconDefaultProps;

LineChartIcon.propTypes = iconPropTypes;
LineChartIcon.defaultProps = iconDefaultProps;

TableIcon.propTypes = iconPropTypes;
TableIcon.defaultProps = iconDefaultProps;

TextIcon.propTypes = iconPropTypes;
TextIcon.defaultProps = iconDefaultProps;

ArrowUpIcon.propTypes = iconPropTypes;
ArrowUpIcon.defaultProps = iconDefaultProps;

